"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DevicePixelRatioWindowSource = /*#__PURE__*/function () {
  function DevicePixelRatioWindowSource() {
    _classCallCheck(this, DevicePixelRatioWindowSource);
  }

  _createClass(DevicePixelRatioWindowSource, [{
    key: "devicePixelRatio",
    value: function devicePixelRatio() {
      if (typeof window === 'undefined' || !window || !window.devicePixelRatio) {
        return 1;
      }

      return window.devicePixelRatio;
    }
  }]);

  return DevicePixelRatioWindowSource;
}();

exports.default = DevicePixelRatioWindowSource;